import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ReactComponent as DeleteTag } from "../../../assets/elevva-pro-icons/delete-tag.svg";
import { ReactComponent as EditTag } from "../../../assets/elevva-pro-icons/edit-tag.svg";
import { ReactComponent as SearchIconAlone } from "../../../assets/elevva-pro-icons/searchIconAlone.svg";
import { ReactComponent as TrophyIcon } from "../../../assets/elevva-pro-icons/trophy.svg";
import { instance, Loadingspinner } from "../../../utils/utils";
import ConfirmDeletionModal from "../../Mob/components/modal-delete";
import ModalInfo from "../../athlete-info/components/modal-info";
import ChallengeCard from "./ChallengeCard";
import ChallengeFormModal from "./challenge-form-modal";
import ChallengeWinnerCard from "./challenge-winner-card";
import { ReactComponent as ArrowLeft } from "../../../assets/elevva-pro-icons/table-arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../assets/elevva-pro-icons/table-arrow-right.svg";
import changePage from "../../Mob/functions/changePage";
import moment from "moment";
import { ReactComponent as Congratulations } from "../../../assets/elevva-pro-icons/congratsIcon.svg";

const ChallengesMembership = () => {
  const iconStyle = {
    cursor: "pointer",
    marginLeft: "0.5rem",
    color: "var(--elevvaTextSubtitle)",
  };
  const iconStyleCongratulations = {
    cursor: "pointer",
    marginLeft: "0.5rem",
    color: "blue",
    fontSize: "2rem",
  };

  const [logs, setLogs] = useState([]);
  const [modal, setModal] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [modalType, setModalType] = useState(null); // 'create' or 'edit'
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [totalCustomers, settotalCustomers] = useState(null);

  const [pageNext, setPageNext] = useState(null);
  const [pageBack, setPageBack] = useState(null);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);

  function getChallenges(value) {
    let url = value ? value : `customers/corp/challenges/`;
    setLoader(true);
    instance
      .get(url)
      .then((res) => res.data)
      .then((data) => {
        data && data.results.length > 0 && setLogs(data.results);

        setPageNext(data.next);
        setPageBack(data.previous);
        setCount(data.count);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoader(false);
      });
  }

  function getPage(value) {
    getChallenges(value);
  }

  function createNewChallenge(e, method, id) {
    e.preventDefault();
    setLoader(true);

    const isEdit = method === "patch";

    const challengeData = {
      name: e.target[2].value,
      end_date: e.target[4].value + " 06:00",
      reward: e.target[5].value,
      description: e.target[6].value,
      score_for_participating: Number(e.target[7].value),
      score_for_winning: Number(e.target[9].value),
      is_active: true,
      participants: selectedMembers,
    };

    const startDateInput = e.target[3];
    if (!isEdit || !startDateInput.disabled) {
      challengeData.start_date = startDateInput.value + " 06:00";
    }

    const file = e.target[0].files[0];

    const apiCall = isEdit
      ? instance.patch(`customers/corp/challenges/${id}/`, challengeData)
      : instance.post("customers/corp/challenges/", challengeData);

    apiCall
      .then((res) => {
        const challengeId = res.data.id || id;

        // If there's a file to upload, do it after creating/updating the challenge
        if (file && file.size > 0) {
          const logoForm = new FormData();
          logoForm.append("logo", file);
          return instance
            .post(
              `customers/corp/challenges/${challengeId}/upload-logo/`,
              logoForm
            )
            .then(() => res); // Return the original response to continue the chain
        }
        return res;
      })
      .then((res) => {
        // Show success message
        setModal(
          <ConfirmDeletionModal
            onCancel={() => {
              setModal(null);
              getChallenges();
            }}
            onConfirm={() => {
              setModal(null);
              getChallenges();
            }}
            loader={false}
          >
            <span
              style={iconStyleCongratulations}
              onClick={() => { }}
              className="my-2"
            >
              <Congratulations />
            </span>
            <br />
            Reto
            <br />
            <strong>{isEdit ? "actualizado" : "creado"}</strong>
            <br />
            <strong>correctamente.</strong>
            <br />
          </ConfirmDeletionModal>
        );

        // Close modal and reset form
        setModalType(null);
        getChallenges();
      })
      .catch((err) => {
        console.error("Error:", err);
        setModalError(
          <ConfirmDeletionModal
            onCancel={() => {
              setModalError(null);
              setModal(null);
            }}
            onConfirm={() => {
              setModalError(null);
              setModal(null);
            }}
            loader={false}
            zIndex={1000}
          >
            {err?.response?.data ? (
              Array.isArray(err.response.data) ? (
                err.response.data.map((msg, idx) => (
                  <p key={idx} className="text-red-500 text-sm">
                    {msg}
                  </p>
                ))
              ) : (
                Object.entries(err.response.data).map(([key, msg], idx) => (
                  <p key={idx} className="text-red-500 text-sm">
                    {msg}
                  </p>
                ))
              )
            ) : (
              <>
                <br />
                Hubo un error
                <br />
                <strong>al {isEdit ? "actualizar" : "crear"} el reto.</strong>
                <br />
              </>
            )}
          </ConfirmDeletionModal>
        );
      })
      .finally(() => {
        // Reset form state
        setLoader(false);
        // setSelectedChallenge(null);
        setSelectedMembers([]);
        setImageUrl(null);
      });
    e.preventDefault();
  }
  function deleteChallenge(record) {
    const handleDelete = () => {
      instance
        .delete(`customers/corp/challenges/${record.id}`)
        .then((res) => {
          if (res.status == "204" || res.status == "200") {
            setModal(
              <ConfirmDeletionModal
                onCancel={() => setModal(null)}
                onConfirm={() => setModal(null)}
                loader={false}
              >
                <br />
                Reto
                <br />
                <strong> eliminado</strong>
                <br />
                <strong>correctamente.</strong>
                <br />
              </ConfirmDeletionModal>
            );
            getChallenges();
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error) {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                {msg_error.detail}
              </ConfirmDeletionModal>
            );
          }
        });
    };
    setModal(
      record && (
        <ConfirmDeletionModal
          onCancel={() => setModal(null)}
          onConfirm={handleDelete}
          loader={false}
        >
          ¿Estás seguro de <br></br>
          <strong>eliminar {record?.name || "el reto"}? </strong>
        </ConfirmDeletionModal>
      )
    );
  }
  const showWinnerConfirm = (e, record) => {
    const handleAction = () => {
      setModal(null);
      instance
        .post(`customers/corp/challenges/${record.id}/participants/winners`, {
          winners: e,
        })
        .then((res) => {
          if (res.status == "204" || res.status == "200") {
            setModal(
              <ConfirmDeletionModal
                onCancel={() => setModal(null)}
                onConfirm={() => setModal(null)}
                loader={false}
                textButton="¡ Listo !"
                customButton={true}
              >
                <br />" ¡Reto completado! {e.length} usuario
                {e.length === 1 ? "" : "s"} han sido premiados"
                <br />
                "Se ha enviado la notificación a sus apps móviles."
                <br />
                <br />
              </ConfirmDeletionModal>
            );
            getChallenges();
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          const status = err.response?.status;
          if (msg_error) {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                {status == 500
                  ? "Error al subir el ganador"
                  : status == 404
                    ? "Pagina no encontrada"
                    : msg_error}
              </ConfirmDeletionModal>
            );
          } else {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                Error al subir el ganador
              </ConfirmDeletionModal>
            );
          }
        });
    };
    setModal(
      <ModalInfo
        overlay={false}
        onCancel={() => setModal(null)}
        buttonConfirmText="Confirmar"
        buttonConfirm={true}
        buttonCancel={true}
        buttonCancelText="Cancelar"
        buttonsWidth="80%"
        maxWidth="20rem"
        onConfirm={handleAction}
        loader={false}
      >
        <strong>¿Desea continuar?</strong>
        <br />
        <hr />
        <p>
          Está seleccionando a {e.length} usuarios que completaron el reto. Esta
          acción enviará notificaciones y desbloqueará sus recompensas. Esta
          acción no se puede deshacer.
        </p>
      </ModalInfo>
    );
  };
  const showWinner = (record) => {
    setModal(
      <ModalInfo
        overlay={false}
        onCancel={() => setModal(null)}
        buttonConfirmText="Seleccionar"
        buttonConfirm={false}
        buttonCancel={false}
        buttonCancelText="Cancelar"
        buttonsWidth="80%"
        maxWidth="90rem"
        onConfirm={() => setModal(null)}
        loader={false}
      >
        <ChallengeWinnerCard
          challenge={record}
          onCancel={() => setModal(null)}
          onConfirm={(e) => showWinnerConfirm(e, record)}
          buttonConfirmText="Seleccionar"
          buttonCancelText="Cancelar"
        />
      </ModalInfo>
    );
  };
  const showChallenge = (record) => {
    setModal(
      <ConfirmDeletionModal
        onCancel={() => setModal(null)}
        onConfirm={() => setModal(null)}
        loader={false}
      >
        <ChallengeCard challenge={record} />
      </ConfirmDeletionModal>
    );
  };

  const MembershipOptionId = localStorage.getItem("MembershipOptionId");
  console.log(MembershipOptionId);
  function getCustomers() {
    instance
      .get(`memberships/corp/members?no_paginate=true`)
      .then((res) => res.data)
      .then((data) => {
        console.log(data);
        settotalCustomers(data);

        // setIdCustomer(data[0].customer);
      })
      .catch((err) => console.error(err));
  }

  useEffect(() => {
    getChallenges();
  }, []);
  useEffect(() => {
    getCustomers();
  }, [MembershipOptionId]);

  const handleCreateChallenge = () => {
    setModalType("create");
    setSelectedChallenge(null);
    setImageUrl(null);
    setSelectedMembers([]);
  };

  const handleEditChallenge = (challenge) => {
    setModalType("edit");
    setSelectedChallenge(challenge);
    setImageUrl(challenge.logo || null);
    setSelectedMembers(challenge.participants?.map((p) => p.id) || []);
  };

  return (
    <div className="text-center  h-100">
      {modal}
      {modalError}

      {modalType && (
        <ChallengeFormModal
          isOpen={!!modalType}
          onClose={() => {
            setModalType(null);
            setSelectedChallenge(null);
            setImageUrl(null);
            setSelectedMembers([]);
          }}
          onSubmit={(e) => {
            e.preventDefault();
            const method = modalType === "create" ? "post" : "patch";
            createNewChallenge(e, method, selectedChallenge?.id);
          }}
          title={modalType === "create" ? "Nuevo" : "Editar"}
          challenge={selectedChallenge}
          imageUrl={imageUrl}
          onImageChange={setImageUrl}
          selectedMembers={selectedMembers}
          onMemberSelect={setSelectedMembers}
          totalCustomers={totalCustomers}
          loader={loader}
        />
      )}
      <div>
        <span
          style={{
            fontSize: "calc(0.4rem + 0.4vw)",
            color: "var(--elevvaTextTitle)",
          }}
        >
          <strong>Retos del centro deportivo</strong>
        </span>
      </div>
      <div className="my-2">
        <button
          className="mx-auto d-flex ver_mas "
          onClick={handleCreateChallenge}
        >
          Crear Reto
        </button>
      </div>
      <hr></hr>
      <div className=" w-100 p-2">
        <div
          className=" w-100"
          style={{
            border: "1px solid #B6C1CE",
            borderRadius: "10px",
          }}
        >
          {loader ? (
            <div
              className="px-2"
              style={{
                height: "calc(100vh - 60px - 13rem)",
                overflowY: "scroll",
                marginTop: "1rem",
              }}
            >
              <Loadingspinner size={"2.5rem"} />
            </div>
          ) : logs.length > 0 ? (
            <PerfectScrollbar
              className="px-2"
              style={{
                minHeight: "calc(100vh - 60px - 13rem)",
                maxHeight: "calc(100vh - 60px - 13rem)",
                overflowY: "scroll",
                marginTop: "1rem",
              }}
            >
              {logs
                .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                .map((element, i) => {
                  const now = moment().startOf("day");
                  const startDate = moment(element.end_date).startOf("day");
                  const endDate = moment(element.end_date)
                    .startOf("day")
                    .add(2, "days");
                  const diffInDays = endDate.diff(now, "days");

                  const isAfter48Hours = diffInDays <= 2;
                  return (
                    <div
                      key={i + "-log"}
                      className="d-flex justify-content-start align-items-center gap-3 px-3 py-3"
                      style={{
                        width: "100%",
                        borderBottom: "1px solid #B6C1CE",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3  justify-content-between w-100">
                        <div className="w-100 d-flex align-items-center">
                          <span
                            style={{
                              fontSize: "calc(0.4rem + 0.4vw)",
                              display: "inline-block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontWeight: "bold",
                              color: "var(--elevvaTextTitle)",
                            }}
                          >
                            {element.name}
                          </span>
                        </div>
                        <div className="d-flex  align-items-center gap-2">
                          {startDate.isSameOrAfter(now) && (
                            <span
                              style={{
                                cursor: "pointer",
                                marginLeft: "0.5rem",
                                color: element.participants.some((p) => p.won)
                                  ? "#EFBF04"
                                  : "var(--elevvaTextSubtitle)",
                              }}
                              onClick={() => showWinner(element)}
                            >
                              <TrophyIcon width="1rem" height="1rem" />
                            </span>
                          )}
                          <span style={iconStyle}>
                            <SearchIconAlone
                              onClick={() => showChallenge(element)}
                            />
                          </span>
                          <span style={iconStyle}>
                            <EditTag
                              onClick={() => handleEditChallenge(element)}
                            />
                          </span>
                          <span style={iconStyle}>
                            <DeleteTag
                              onClick={(e) => deleteChallenge(element)}
                            />
                          </span>
                        </div>
                      </div>{" "}
                    </div>
                  );
                })}
            </PerfectScrollbar>
          ) : (
            <div
              style={{
                height: "calc(100vh - 60px - 11rem)",

                marginTop: "1rem",
              }}
            >
              No hay registros
            </div>
          )}

          <div className="d-flex justify-content-end align-items-center gap-3 mb-3 px-3">
            <span>
              {page * 10 - 10 === 0 || count >= 10
                ? page === 1
                  ? 1
                  : count
                : page * 10 - 10}
              - {page * 10 >= count ? count : page * 10} de {count}
            </span>
            <div
              onClick={
                count <= 10
                  ? null
                  : () =>
                    changePage(
                      "previous",
                      getPage,
                      pageNext,
                      pageBack,
                      page,
                      count,
                      setPage
                    )
              }
              className="cursor-pointer"
            >
              <ArrowLeft />
            </div>
            <div
              onClick={
                page * 10 >= count
                  ? null
                  : () =>
                    changePage(
                      "next",
                      getPage,
                      pageNext,
                      pageBack,
                      page,
                      count,
                      setPage
                    )
              }
              className="cursor-pointer"
            >
              <ArrowRight />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengesMembership;
